<template>
    <div>
        <form-header title="Antrag auf Strukturförderung für KUKUDU® Zirkel" subtitle="" tag="KUKUDU"></form-header>

        <ValidationObserver ref="form">
            <div>
                <div class="bg-primary">
                    <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                        <transition name="fade">
                            <div class="mt-0 mb-4 bg-red-100 border-2 border-red-200 px-4 py-4 sm:rounded-lg sm:p-4"
                                v-show="formbehaviour.alertrequired">
                                <div class="md:grid md:grid-cols-1 md:gap-3">
                                    <div class="md:col-span-1">
                                        <h3 class="leading-3">
                                            Bitte überprüfen Sie Ihre Eingabe! Laden Sie alle Kooperationsvereinbarungen hoch.
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </transition>

                        <form-section title="Angaben zur Musikschule" subtitle="Bitte wählen Sie Ihre Schule aus.">
                            <drop-down :values="formdata.musikschulen" v-model="ansuchen.musikschuleId"
                                label="Musikschule" :rules="'required'" columns="5"></drop-down>
                            <text-input v-model="ansuchen.eMail" label="Kontakt E-Mail-Adresse" rules="required|email"
                                            columns="5"></text-input>
                        </form-section>

                        <div class="mb-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6" v-for="(lehrperson, i)  in ansuchen.lehrpersonen" :key="i">
                            <div class="md:grid md:grid-cols-3 md:gap-6">
                                <div class="md:col-span-1">
                                    <h3 class="text-lg font-medium leading-6 text-gray-900">{{ (i + 1) + ' .Lehrpersonen' }}</h3>
                                    <button @click="removeLehrperson(i)" v-if="ansuchen.lehrpersonen.length > 1"
                                    class="mt-2 rounded-md bg-red-500 px-2 py-1 text-white text-sm">entfernen</button>
                                </div>
                                <div class="mt-5 md:mt-0 md:col-span-2">
                                    <div class="grid grid-cols-6 gap-6 items-end">

                                        <text-input v-model="lehrperson.titel" label="Titel vor."
                                            columns="1"></text-input>
                                        <text-input v-model="lehrperson.vorname" label="Vorname" rules="required"
                                            columns="2"></text-input>
                                        <text-input v-model="lehrperson.nachname" label="Nachname" rules="required"
                                            columns="2"></text-input>
                                        <text-input v-model="lehrperson.titelNachgestellt" label="Titel nach."
                                            columns="1"></text-input>

                                        <text-input v-model="lehrperson.entlohnungsGruppe"
                                            label="Entlohungsgruppe Gemeinde" rules="required" columns="2"></text-input>
                                        <text-input v-model="lehrperson.entlohnungsStufe" label="Entlohungsstufe"
                                            rules="required" columns="2"></text-input>
                                        <text-input v-model="lehrperson.abschlussKukudu"
                                            label="Datum des Abschluss vom KUKUDU Coaching" columns="2" type="date">
                                        </text-input>

                                        <div v-for="(zirkel, zi) in lehrperson.zirkel" :key="zi"
                                            class="col-span-6 grid grid-cols-6 gap-4 border rounded-md p-4 bg-gray-50 relative">
                                            <drop-down :values="distinctBezirke" v-model="zirkel.bezirkId"
                                                label="Bezirk" :rules="'required'" columns="2"></drop-down>
                                            <drop-down :values="formdata.kindergaerten.filter(k => k.bezirkId == zirkel.bezirkId)" v-model="zirkel.kindergartenId"
                                                label="Kindergarten" :rules="'required'" columns="3"></drop-down>
                                            <text-input v-model="zirkel.anzahlKinder" label="Anzahl Kinder"
                                                rules="required" columns="1" type="number"></text-input>
                                            <button @click="removeZirkel(lehrperson, zi)" v-if="lehrperson.zirkel.length > 1"
                                                class="absolute top-0 right-0 rounded-bl-md bg-red-500 px-2 py-1 text-white flex items-center justify-center text-xs">entfernen</button>
                                        </div>
                                        <button v-if="lehrperson.zirkel.length < 10" @click="zirkelHinzufuegen(i)"
                                            type="button"
                                            class="col-span-2 items-center py-1 border border-transparent text-sm leading-6 font-medium rounded-md text-white bg-noeBlue hover:opacity-75 transition ease-in-out duration-150">
                                            weiteren Zirkel hinzufügen
                                        </button>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <form-section>
                            <button @click="lehrpersonHinzufuegen(i)" type="button"
                                class="col-span-2 items-center py-1 border border-transparent text-sm leading-6 font-medium rounded-md text-white bg-noeBlue hover:opacity-75 transition ease-in-out duration-150">
                                weitere Lehrperson hinzufügen
                            </button>
                        </form-section>



                        <form-section title="Kooperationsvereinbarungen" v-if="distinctKindergaerten.length > 0">
                            <file-upload v-for="kindergartenId in distinctKindergaerten"
                                :label="'Kindergarten ' + formdata.kindergaerten.find(kg => kg.id == kindergartenId).name + '*'"
                                :key="kindergartenId" columns="4" :maxSize="5" 
                                @size-exceeded="onKoopSizeExceeded" @metadata="(file) => onKoop(file, kindergartenId)"
                                @fileloaded="(file) => onKoopLoaded(file, kindergartenId)"></file-upload>
                        </form-section>



                        <form-section title="Informationspflicht" subtitle="gem. Art. 13 DSGVO">
                            <div class="col-span-6 sm:col-span-5">
                                <text-block :content="textbausteinfuer(
                                    'allgemein.informationspflicht'
                                )
                                    " />
                            </div>
                        </form-section>



                        <div class="mt-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
                            <div class="md:grid md:grid-cols-3 md:gap-6">
                                <div class="md:col-span-1">&nbsp;</div>
                                <div class="grid grid-cols-6 gap-6">
                                    <div class="col-span-6">
                                        <span class="inline-flex rounded-md shadow-sm">
                                            <button @click="openSubmitModal()" type="button"
                                                class="inline-flex items-center px-48 sm:px-8 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-green active:bg-green-700 transition ease-in-out duration-150">
                                                Ansuchen absenden
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ValidationObserver>

        <transition name="fade">
            <div v-show="formbehaviour.showSendModal"
                class="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center">
                <div v-show="formbehaviour.showSendModal" class="fixed inset-0 transition-opacity">
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <div v-show="formbehaviour.showSendModal"
                    class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6">
                    <div>
                        <div class="mt-3 text-center sm:mt-5">
                            <div class="mt-2">
                                <p class="text-sm leading-5 text-gray-500">
                                    Wollen sie das Ansuchen absenden?
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                        <span class="flex w-full rounded-md shadow-sm sm:col-start-2">
                            <button @click="sendAnsuchen()" type="button" :disabled="formbehaviour.sending"
                                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 text-base leading-6 font-medium text-white shadow-sm focus:outline-none transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                                :class="[
                                    formbehaviour.sending ? ' bg-gray-300'
                                        : 'bg-green-600 hover:bg-green-500 focus:border-green-700 focus:shadow-outline-green'
                                ]">
                                Absenden
                            </button>
                        </span>
                        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:col-start-1">
                            <button @click="formbehaviour.showSendModal = false" type="button"
                                :disabled="formbehaviour.sending"
                                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 text-base leading-6 font-medium shadow-sm transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                                :class="[
                                    formbehaviour.sending ? ' bg-gray-300 text-white'
                                        : 'bg-white text-gray-700 focus:outline-none focus:border-blue-300 focus:shadow-outline hover:text-gray-500'
                                ]">
                                Zurück
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div
                class="fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end">
                <div v-show="formbehaviour.sending"
                    class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto">
                    <div class="rounded-lg shadow-xs overflow-hidden">
                        <div class="p-4">
                            <div class="flex items-start">
                                <div class="flex-shrink-0">
                                    <svg class="h-6 w-6 text-green-400" fill="none" viewBox="0 0 24 24"
                                        stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                                <div class="ml-3 w-0 flex-1 pt-0.5">
                                    <p class="text-sm leading-5 font-medium text-gray-900">
                                        Validierung erfolgreich.
                                    </p>
                                    <p class="mt-1 text-sm leading-5 text-gray-500">
                                        Übermittle das Ansuchen.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div v-show="formbehaviour.successful"
                class="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center">
                <div v-show="formbehaviour.successful" class="fixed inset-0 transition-opacity">
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <div v-show="formbehaviour.successful"
                    class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-sm sm:w-full sm:p-6">
                    <div>
                        <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                            <svg class="h-6 w-6 text-green-600" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M5 13l4 4L19 7" />
                            </svg>
                        </div>
                        <div class="mt-3 text-center sm:mt-5">
                            <h3 class="text-lg leading-6 font-medium text-gray-900">
                                Erfolgreich gesendet.
                            </h3>
                            <div class="mt-2">
                                <p class="text-sm leading-5 text-gray-500">
                                    Vielen Dank.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import FormSection from '@/components/forms/FormSection.vue'
import FormHeader from '@/components/forms/FormHeader.vue'

import TextInput from '@/components/inputs/TextInput.vue'
import CheckBox from '@/components/inputs/CheckBox.vue'
import DropDown from '@/components/inputs/DropDown.vue'
import RadioButtonList from '@/components/inputs/RadioButtonList.vue'
import TextBlock from '@/components/inputs/TextBlock.vue'

import FileUpload from '@/components/inputs/FileUpload.vue'


export default {
    name: 'Form',
    inject: ['service'],
    components: {
        TextInput,
        CheckBox,
        DropDown,
        FormSection,
        FormHeader,
        RadioButtonList,
        TextBlock,
        FileUpload,
    },
    data: function () {
        return {
            formbehaviour: {
                showSendModal: false,
                sending: false,
                successful: false,
            },
            formdata: {
                musikschulen: [],
                kindergaerten: [],
            },
            ansuchen: {
                musikschule: null,
                musikschuleId: null,
                eMail: null,

                lehrpersonen: [{
                    vorname: null,
                    nachname: null,
                    titel: null,
                    titelNachgestellt: null,
                    entlohnungsGruppe: null,
                    entlohnungsStufe: null,
                    abschlussKukudu: null,
                    zirkel: [
                        {
                            bezirkId: null,
                            kindergartenId: null,
                            kindergarten: null,
                            anzahlKinder: null
                        }
                    ]
                }],
                anhaenge: [],
            },
        }
    },
    watch: {
    },
    computed: {
        distinctKindergaerten() {
            let kindergartenIds = this.ansuchen.lehrpersonen.flatMap(person => person.zirkel.map(z => z.kindergartenId));
            let uniqueKindergartenIds = [...new Set(kindergartenIds)].filter(id => id !== null);

            return uniqueKindergartenIds;
        },
        distinctBezirke() {
            let bezirke = this.formdata.kindergaerten.map(k => { 
                return {
                    id: k.bezirkId,
                    name: k.bezirk
                };
            });
           
            const bezirkeDistinct = [...new Map(bezirke.map(item =>
                [item['id'], item])).values()];

            return bezirkeDistinct.sort((a, b) => a.name.localeCompare(b.name));;
        },
    },
    created: function () {
        this.fetchTextBausteine();
        this.fetchMusikschulen();
        this.fetchKindergaerten();
    },
    methods: {
        removeLehrperson(index){
            this.ansuchen.lehrpersonen.splice(index, 1);
        },
        removeZirkel(lehrperson,index){
            lehrperson.zirkel.splice(index, 1);
        },
        
        async fetchTextBausteine() {
            const { data } = await this.service.formular
                .get('kukudufoerderung')
                .textbloecke()
            this.formdata.textbausteine = data
        },

        async fetchMusikschulen() {
            const { data } = await this.service.musikschule.powerAppsAlle()
            this.formdata.musikschulen = data
            this.formdata.musikschulen.sort((a, b) =>
                a.kurzbezeichnung > b.kurzbezeichnung ? 1 : -1
            )
        },

        async fetchKindergaerten() {
            const { data } = await this.service.musikschule.kindergaerten()
            this.formdata.kindergaerten = data
            this.formdata.kindergaerten.sort((a, b) =>
                a.kurzbezeichnung > b.kurzbezeichnung ? 1 : -1
            )
        },
        zirkelHinzufuegen(lehrpersonIndex) {
            this.ansuchen.lehrpersonen[lehrpersonIndex].zirkel.push({
                kindergartenId: null,
                kindergarten: null,
                anzahlKinder: null
            });
        },
        lehrpersonHinzufuegen() {
            this.ansuchen.lehrpersonen.push({
                vorname: null,
                nachname: null,
                titel: null,
                titelNachgestellt: null,
                entlohnungsGruppe: null,
                entlohnungsStufe: null,
                abschlussKukudu: null,
                zirkel: [
                    {
                        kindergartenId: null,
                        kindergarten: null,
                        anzahlKinder: null
                    }
                ]
            });
        },

        async sendAnsuchen() {
            if (this.formbehaviour.sending) {
                return;
            }

            try {
                this.formbehaviour.sending = true
                this.ansuchen.musikschule = this.formdata.musikschulen.find(m => m.id == this.ansuchen.musikschuleId).name;

                this.ansuchen.lehrpersonen.forEach(lp => {
                    lp.zirkel.forEach(zi => {
                        zi.kindergarten = this.formdata.kindergaerten.find(m => m.id == zi.kindergartenId).name;
                    });
                });

                this.ansuchen.anhaenge.forEach(an => {
                    an.subject = "Kooperation - " + this.formdata.kindergaerten.find(m => m.id == an.kindergartenId).name;
                });

                await this.service.kukudufoerderung.senden(this.ansuchen)
                this.formbehaviour.showSendModal = false
                this.formbehaviour.successful = true

            } catch (error) {
                console.log(Object.keys(error), error.message)
            } finally {
                this.formbehaviour.sending = false
            }
        },

        openSubmitModal() {
            this.$refs.form.validate().then(success => {
                if (!success) {
                    window.scrollTo(0, 0)
                    this.formbehaviour.alertrequired = true
                    return
                }

                if(this.ansuchen.anhaenge.filter(ah => ah.body == null).length > 0 || this.ansuchen.anhaenge.length != this.distinctKindergaerten.length){
                    window.scrollTo(0, 0)
                    this.formbehaviour.alertrequired = true
                    return
                }

                this.formbehaviour.showSendModal = true
            })
        },

        textbausteinfuer(id) {
            if (!this.formdata.textbausteine) {
                return "Textbausteine nicht geladen."
            }

            const found = this.formdata.textbausteine.find(
                element => element.identifier == id
            )

            if (!found) return id

            return found.content
        },

        onKoop(file, kindergartenId) {
            var anhang = this.ansuchen.anhaenge.find(an => an.kindergartenId == kindergartenId);

            if(anhang){
                anhang.mimeType = file.type
                anhang.filename = file.name
            }
            else{
                this.ansuchen.anhaenge.push({
                    kindergartenId: kindergartenId,
                    subject: 'Kooperationsvereinbarung',
                    filename: file.name,
                    mimeType: file.type,
                    body: null,
                });
            }
        },

        onKoopLoaded(dataUri, kindergartenId) {
            this.ansuchen.anhaenge.find(an => an.kindergartenId == kindergartenId).body = dataUri
        },

        onKoopSizeExceeded(size) {
            alert(`Datei mit ${size}MB zu groß. (Maximal 5 MB)`)
        },
    },
    beforeDestroy() { },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
